"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFormattingTokens = void 0;
/**
 * Removes the formatting escape characters ('[' and ']') from a string passed into the formatDate method.
 * Matches the functionality provided by date-fns.
 * @hidden
 * @param value The original string value.
 * @returns The sanitised string value.
 */
var removeFormattingTokens = function (value) {
    return value.replace(/^\[|]$/g, '');
};
exports.removeFormattingTokens = removeFormattingTokens;
//# sourceMappingURL=remove-formatting-tokens.js.map